﻿import DefaultApp from './defaultApp';
import OutstandingPayment from './components/OutstandingPayment.vue';
import Tab from './components/tabs/tab.vue';
import Tabs from './components/tabs/tabs.vue';
import datatable from './components/dataTable.vue';
import bulmaCollapsible from '@creativebulma/bulma-collapsible';

const claimDetailApp = {
    ...DefaultApp,
    components: {
        OutstandingPayment,
        Tab,
        Tabs,
        datatable
    },
    data() {
        return {
            ...DefaultApp.data(),
            api: '',
            data: {},
            loading: false,
        }
    },
    methods: {
        ...DefaultApp.methods,
        async init() {
            this.loading = true;
            let invoiceResponse = await this.fetchData({}, this.api, 'get');
            if (invoiceResponse.status === 200) {
                this.data = invoiceResponse.data;
                this.loading = false;
                this.$nextTick(() => {
                    bulmaCollapsible.attach('.is-collapsible');
                    this.$refs.invoices.getData();
                    this.$refs.payments.getData();
                });
            }
        },
        getDate(date) {
            let d = new Date(date);
            return new Intl.DateTimeFormat('nl-NL', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            }).format(d)
        },
        getDateTime(date) {
            let d = new Date(date);
            return new Intl.DateTimeFormat('nl-NL', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(d)
        }
    },
    mounted() {
        if (this.$el.parentNode.dataset.api) this.api = this.$el.parentNode.dataset.api;
        this.init();
    }
}


export default claimDetailApp;